import { render, staticRenderFns } from "./softwareDocTable.vue?vue&type=template&id=3ea2d318&"
import script from "./softwareDocTable.vue?vue&type=script&lang=js&"
export * from "./softwareDocTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports